import Grid from "@mui/material/Grid";
import {EventCard} from "../EventCard.jsx";
import {today} from "../../shared/date.js";
import { useEvents } from "../DanceEventProvider.jsx";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Box } from "@mui/material";

export const EventPage = (props) => {

    const [loadedEvents, setLoadedEvents] = useState([]); // <-- new state
    const {venueKey, date} = props.match.params;

    useEffect(() => {
        if (date < today()) {
            // Fetch historical events for this date
            const fetchOldEvents = async () => {
                try {
                    const res = await fetch(
                        `${process.env.REACT_APP_BACKEND_HOST}/events?filters[date][$eq]=${date}&populate=*`
                    );
                    const data = await res.json();
                    setLoadedEvents(data.data || []);
                } catch (e) {
                    setLoadedEvents([]);
                }
            };
            fetchOldEvents();
        }
    }, [date, venueKey])
   
    let {events} = useEvents();

    events = date < today() ? loadedEvents : events.filter(e => e.venue.venueKey === venueKey && e.date === date)

    const event = events[0];
    if (!event) return <Box>
        <Helmet>
            <title>{event ? event.title : `Event Details`}</title>
            <link rel="canonical" href={`https://austin2step.com/event/${venueKey}/${date}`} />
        </Helmet>
            No Event Found
    </Box>

    return <Grid container>
            <Grid item xs={12}>
                <Helmet>
                    <title>{event ? event.title : `Event Details ${event?.venue.name}`}</title>
                    <link rel="canonical" href={`https://austin2step.com/event/${venueKey}/${date}`} />
                </Helmet>
            </Grid>
            <Grid item xs={12}>
                {event && <EventCard event={event} />}
            </Grid>
        </Grid>
}